import React from "react";

const CannabisShowCaseLoading = () => {
    return (
        <div className="cms cms--cannabisshowcase">
            <div className="container">
                <div className="cannabisbanner">
                    <span>Cannabis Showcase</span>
                </div>
                <div className="jumbotron jumbotron-fluid border rounded py-4 m-0">
                    <div className="px-3">
                        <h1>Something went wrong!</h1>
                        <p>
                            Please refresh this page or try again later.
                        </p>
                        <hr className="my-4" />
                        <p>
                            If you would like to visit the home page, please use
                            the link below:
                        </p>
                        <p className="lead mb-0">
                            <a
                                className="btn btn-danger btn-lg"
                                href="/"
                                role="button"
                            >
                                Go to Homepage
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CannabisShowCaseLoading;
